// extracted by mini-css-extract-plugin
module.exports = {"title":"LogoSlider_title__0Uu6a","image":"LogoSlider_image__qC59_"};